var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResumeNote',{staticClass:"one-response-note-card",attrs:{"value":_vm.value,"author-name":_vm.authorName,"time":_vm.time},on:{"save":_vm.saveNote}})}
var staticRenderFns = []

export { render, staticRenderFns }